import type { LayoutSetting, OptionKeys } from './model';

/**
 * Display sidebar menu options depending on flags and user role
 * @param params User settings
 * @returns Filtered user settings
 */
export function processViewSettings(
  settings: (string | boolean | undefined)[][][]
) {
  const result: (readonly OptionKeys[])[] = [];
  settings.forEach((curr) => {
    const group = curr.reduce<readonly OptionKeys[]>((section, currKey) => {
      const [item, isEnabled] = currKey;
      if (isEnabled) {
        section = section.concat([item as unknown as OptionKeys]);
      }
      return section;
    }, []);

    result.push(group);
  });
  return result as LayoutSetting;
}
